import * as angular from "angular";
import {IController} from "angular";

export class BringozSliderComponent implements IController {
  date: any;
  min: any;
  max: any;
  ticks: any;
  noOutput: any;
  onChange: Function;

  defaultTicks: number = 60000;
  width: any;
  dateOutput: any;

  constructor() {
  }

  $onInit() {
    this.ticks = this.ticks ? this.ticks : this.defaultTicks;
    this.dateOutput = this.getOutputPercentage(this.date);
  };

  onSliderInit() {
    this.width = document.getElementById('input-from').clientWidth;
    this.dateOutput = this.getOutputPercentage(this.date);
  };

  $onChanges(changes) {
    if (changes.date && !changes.date.isFirstChange()) {
      this.date = changes.date.currentValue;
      this.dateOutput = this.getOutputPercentage(this.date);
    }
    if (changes.min && !changes.min.isFirstChange()) {
      this.dateOutput = this.getOutputPercentage(this.date);
    }
    if (changes.max && !changes.max.isFirstChange()) {
      this.dateOutput = this.getOutputPercentage(this.date);
    }
  };

  onFromChanged(date) {
    this.dateOutput = this.getOutputPercentage(date);
    this.onChange({date: date});
  }

  private getOutputPercentage(outputValue) {
    let percentage = (outputValue - this.min) * 100 / (this.max - this.min);
    let offset = percentage > 30 ? 12 : 10;
    return percentage - (percentage / offset) + '%';
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozSlider', {
    bindings: {
      date: '<',
      min: '<',
      max: '<',
      ticks: '<', // In Milliseconds
      noOutput: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-slider/bringoz-slider.html',
    controller: BringozSliderComponent
  });
